import React from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import {
  valueFormat,
  growthFormat,
} from '@/pages/intelligence/utils/commonUtils';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { useIntl, getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { SortShowType } from '@/pages/intelligence/pages/Following/_hook/useFollowingOptionList';
import { Rate } from 'tea-component';
import TableChart from '@/pages/intelligence/components/TableComponents/components/TableChart';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { calculateCountryChartList } from '@intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import { createDataSourceMetricForValue } from '@/pages/intelligence/pages/Following/_config/util';

interface FollowingTableCloumsType {
  key: string;
  title: string;
  dataSource: string;
  apiSource: string; //用于排序参数
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: React.ReactNode;
  tipText?: React.ReactNode;
  width?: number | 'auto';
  width_cn?: number | 'auto';
  renderType: RenderType;
  onlySimpleSort?: boolean;
  isDetailPage?: boolean;
  // getMetricValueOfCvm: (cvm: any, metricKey: string) => any;
  isNoDropdown?: boolean;
  align?: 'left' | 'right' | 'center';
  sortIconType?: SortShowType;
  // sortMetricNew?: SortShowType;
  // dataSourceNew?: SortShowType;
  dateType: string;
  entityType?: string;
  icon?: string;
  metricKey?: string;
}
export const FollowingTableCloums = (params: FollowingTableCloumsType) => {
  const {
    key,
    title,
    sortMetric,
    dataSource,
    apiSource,
    currentSortKey,
    currentSortValue,
    textContent,
    tipText,
    onSortChage,
    renderType,
    width = 180,
    width_cn,
    onlySimpleSort,
    isDetailPage = false,
    // getMetricValueOfCvm = () => console.log,
    entityType,
    align: tableAlign,
    sortIconType,
    dateType,
    // sortMetricNew,
    // dataSourceNew,
    icon,
    metricKey = ''
  } = params;
  const { formatMessage } = useIntl();
  const locale = getLocale();

  const localeWidth = locale === LANGUAGE_CN ? width_cn || width : width;

  const maxNumberCal = 9999;
  const maxNumberShow = '9999+%';
  const isRetentionKeys = ['D2', 'D3', 'D7', 'D15', 'D31'].includes(title);

  /**当不是环比排序时，表格标题文本有提示文本 */
  const showTextBubble = currentSortKey !== `${key}_1`;
  const tableTitle = title;

  const align = tableAlign ? tableAlign : 'right';

  return {
    key: key,
    width: localeWidth,
    align: 'center',
    header: () => {
      return (
        <CloumsCenter width={localeWidth} align={align}>
          <SortBy
            align={align}
            title={tableTitle}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            svgIcon={getDataSourceIcon(icon ? icon : dataSource)}
            onlySimpleSort={sortIconType === SortShowType.SIMPLE}
            // isNoDropdown={isNoDropdownVal}
            list={
              sortIconType === SortShowType.SIMPLE
                ? [
                  {
                    key: `${key}_0`,
                    sortMetric: sortMetric,
                    orderSource: apiSource,
                    // sortMetricNew: sortMetricNew || '',
                    // dataSourceNew: dataSourceNew || '',
                    text: title,
                    title: tableTitle,
                    ratioType: 0,
                  },
                ]
                : [
                  {
                    key: `${key}_0`,
                    sortMetric: sortMetric,
                    orderSource: apiSource,
                    // sortMetricNew: sortMetricNew || '',
                    // dataSourceNew: dataSourceNew || '',
                    text: title,
                    title: tableTitle,
                    ratioType: 0,
                  },
                  {
                    key: `${key}_1`,
                    sortMetric: sortMetric,
                    orderSource: apiSource,
                    // sortMetricNew: sortMetricNew || '',
                    // dataSourceNew: dataSourceNew || '',
                    text: `${title}:${formatMessage({
                      id: 'dbi_change',
                    })}(%)`,
                    title:
                      tableTitle?.indexOf('$') > -1
                        ? `${tableTitle}%`
                        : `${tableTitle}(%)`,
                    ratioType: 1,
                  },
                ]
            }
            onChange={onSortChage}
            svgTip={
              renderType === RenderType.RATINGS ? null : (
                <DataSourceBubbleInfo
                  metricKey={metricKey || sortMetric}
                  entityType={entityType}
                  dataOfDom={
                    <>
                      {dataSource === 'steamcharts' && (
                        <img src={getDataSourceIcon(icon ? icon : dataSource)} />
                      )}
                      {isRetentionKeys ? `Retention ${title}` : title}
                    </>
                  }
                  comesFormDom={
                    <>
                      <img src={getDataSourceIcon(icon ? icon : dataSource)} />
                      {DATASOURCE_NAME[dataSource]}
                    </>
                  }
                  dataSource={dataSource === 'steam' && ['acu','pcu'].includes(sortMetric) ? 'vginsights' : dataSource}
                />
              )
            }
            content={showTextBubble && textContent ? textContent : null}
          />
        </CloumsCenter>
      );
    },
    render: (cvm: any) => {
      // const { value, growthDataObj } = getMetricValueOfCvm(cvm, sortMetric);
      const metrics = cvm?.metric_list || [];
      const metric = metrics.find((item: any) => {
        return createDataSourceMetricForValue(item?.metric, item?.data_source) === key;
      });

      if (renderType === RenderType.RANK_AND_RATIO) {
        const value = valueFormat(metric?.value);
        const growthDataObj = growthFormat({
          value: metric?.dod,
          valueType: 'rankValue',
          hasPoint: 'none',
          fixedNum: 0,
          maxNumber: 9999,
          zeroValue: '=',
        });
        return (
          <CloumsCenter width={localeWidth} align={align}>
            <TableShowData
              maxNumber={'9999+'}
              value={value}
              type={growthDataObj?.type}
              growth={growthDataObj?.value}
            />
          </CloumsCenter>
        );
      } else if (renderType === RenderType.RATINGS) {
        return (
          <CloumsCenter width={localeWidth} align={'left'}>
            {/**TODO: 样式修改，需要改成情报的样式 dbi- */}
            <div className="dbo-ratingstar">
              <Rate readonly theme="primary" allowHalf value={metric?.value} />
              <span className="dbo-ratingstar-text">
                {/* 这是显示整数，开发需要注意处理数据 */}
                {metric?.value ? Number(metric?.value).toFixed(1) : 0}
              </span>
            </div>
          </CloumsCenter>
        );
      } else if (renderType === RenderType.GROWTH_AND_RATIO) {
        //TODO: acquisition:value*100%
        //(Math.round(value * 100) + '%')
        const valueDataObj = growthFormat({
          value: metric?.value,
          valueType: isRetentionKeys ? 'percentValue' : 'pointValue',
          hasPoint: 'all',
          fixedNum: 2,
          maxNumber: maxNumberCal,
        });
        const growthDataObj = growthFormat({
          value: metric?.dod,
          valueType: 'pointValue',
          hasPoint: isRetentionKeys ? 'all' : 'lessThanOne',
          fixedNum: 2,
          maxNumber: maxNumberCal,
        });
        return (
          <CloumsCenter width={localeWidth} align={align}>
            <TableShowData
              maxNumber={maxNumberShow}
              value={valueDataObj?.value}
              type={growthDataObj?.type}
              growth={growthDataObj?.value}
            />
          </CloumsCenter>
        );
      } else if (renderType === RenderType.COUNTRY_CHART) {
        const list = calculateCountryChartList(metric);
        return !list?.length ? (
          <CloumsCenter width={localeWidth} align={align}>
            <>-</>
          </CloumsCenter>
        ) : (
          <TableChart
            tableData={{
              title: `${formatMessage({ id: 'dbi_top_asof' })} ${showTimeByDateType(
                metric?.latest_time,
                dateType,
              )}`,
              list: list,
            }}
          />
        );
      } else if (
        renderType === RenderType.STEAM_PRICE ||
        renderType === RenderType.PRICE
      ) {
        const value = valueFormat(metric?.value, false, 0);
        const growthDataObj = growthFormat({
          value: metric?.dod ?? metric?.growth_ratio,
          valueType: 'pointValue',
          hasPoint: 'lessThanOne',
          fixedNum: 2,
          maxNumber: maxNumberCal,
        });
        const showEchart =
          renderType === RenderType.STEAM_PRICE && !isDetailPage;
        return (
          <CloumsCenter width={localeWidth} align={align}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              {showEchart && (
                <div
                  style={{ height: 34, width: 120, marginRight: '8px' }}
                  id={'echarts' + cvm?.id}
                ></div>
              )}
              <div style={{ width: 128 }}>
                <TableShowData
                  maxNumber={maxNumberShow}
                  value={value == 0 ? 'Free' : value}
                  type={growthDataObj?.type}
                  growth={growthDataObj?.value}
                />
              </div>
            </div>
          </CloumsCenter>
        );
      } else {
        const value = valueFormat(metric?.value);
        const growthDataObj = growthFormat({
          value: metric?.dod,
          valueType: 'pointValue',
          hasPoint: 'lessThanOne',
          fixedNum: 2,
          maxNumber: 99999,
        });
        return (
          <CloumsCenter width={localeWidth} align={align}>
            <TableShowData
              maxNumber={maxNumberShow}
              value={value}
              type={growthDataObj?.type}
              growth={growthDataObj?.value}
            />
          </CloumsCenter>
        );
      }
    },
  };
};
